/* Independent Veravita enhancements. Native Dawn handles catalog and cart. */
(() => {
  if (!customElements.get('vv-packs')) customElements.define('vv-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.info = this.closest('product-info');
      if (!this.info) return;
      this.button = this.querySelector('[data-pack-submit]');
      if (!this.button) return;
      this.variantId = this.dataset.variantId;
      this.button.addEventListener('click', () => this.add());
      this.addEventListener('change', () => this.updateSticky());
      const forced = new URLSearchParams(location.search).get('pack');
      if (['1','2','3','4'].includes(forced)) {
        const radio = this.querySelector(`input[type="radio"][value="${forced}"]`);
        if (radio) radio.checked = true;
      }
      if (!this.querySelector('input[type="radio"]:checked')) this.querySelector('input[type="radio"]')?.click();
      this.info.classList.add('vv-packs-active');
      this.hidden = false;
      this.setAvailable(this.dataset.available === 'true');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          this.variantId = data.variant?.id;
          this.setAvailable(Boolean(data.variant?.available));
          if (!data.variant) return;
          const selected = this.querySelector('input[type="radio"]:checked')?.value;
          const fresh = data.html.querySelector(`vv-packs[data-section="${this.dataset.section}"]`);
          if (fresh) {
            const labels = [...fresh.querySelectorAll('[data-pack-qty]')];
            labels.forEach(label => {
              const target = this.querySelector(`[data-pack-qty="${label.dataset.packQty}"]`);
              if (target) target.replaceWith(label.cloneNode(true));
            });
            const chosen = this.querySelector(`input[type="radio"][value="${selected}"]`);
            if (chosen) chosen.checked = true;
          }
          this.updateSticky();
        });
      }
      this.updateSticky();
    }
    disconnectedCallback() { this.unsubscribe?.(); this.initialized = false; }
    setAvailable(available) {
      this.available = available;
      this.button.disabled = !available;
      this.button.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
    }
    updateSticky() {
      const price = this.querySelector('input[type="radio"]:checked')?.closest('label')?.querySelector('[data-pack-total]')?.textContent;
      if (price) this.info.querySelector('vv-sticky-buy span')?.replaceChildren(document.createTextNode(price));
    }
    async add() {
      if (this.busy || !this.available) return;
      const radio = this.querySelector('input[type="radio"]:checked');
      const quantity = Number(radio?.value || 1);
      const formVariant = this.info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variant = formVariant || this.variantId;
      const error = this.querySelector('.vv-pack-error');
      error.hidden = true;
      if (!variant) { error.textContent = 'Elegí una variante disponible.'; error.hidden = false; return; }
      const items = [{id: variant, quantity}];
      const gift = this.dataset.giftId;
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(s => s.id) || [];
      this.busy = true; this.button.disabled = true; this.button.textContent = 'AGREGANDO...';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items, sections, sections_url:location.pathname})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'No pudimos agregar el producto. Revisá la disponibilidad e intentá nuevamente.');
        if (drawer && data.sections && sections.every(id => data.sections[id])) {
          drawer.classList.remove('is-empty');
          drawer.setActiveElement?.(this.button);
          // Drawer rendering failure must not retry the add: items are already in cart.
          try { drawer.renderContents(data); } catch (_) { location.assign(root+'cart'); }
        } else location.assign(root+'cart');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'veravita-packs',productVariantId:variant,cartData:data});
      } catch (err) {
        error.textContent = err.message || 'No pudimos completar la solicitud. Revisá tu conexión e intentá nuevamente.';
        error.hidden = false;
      } finally {
        this.busy = false; this.setAvailable(this.available);
      }
    }
  });
  if (!customElements.get('vv-sticky-buy')) customElements.define('vv-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      const info = this.closest('product-info'); if (!info) return;
      const target = info.querySelector('vv-packs:not([hidden])') || info.querySelector('.product-form__buttons') || info;
      this.querySelector('button')?.addEventListener('click', () => {
        const pack = info.querySelector('vv-packs:not([hidden])');
        const button = pack?.querySelector('[data-pack-submit]') || info.querySelector('[name="add"]');
        (pack || button || info).scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
        button?.focus({preventScroll:true});
      });
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        document.body.classList.toggle('vv-has-sticky', !this.hidden);
      }, {threshold:0});
      this.observer.observe(target);
    }
    disconnectedCallback(){this.observer?.disconnect();document.body.classList.remove('vv-has-sticky');}
  });
  if (!customElements.get('vv-image-compare')) customElements.define('vv-image-compare',class extends HTMLElement {
    connectedCallback(){this.querySelector('input')?.addEventListener('input',e=>this.style.setProperty('--reveal',e.target.value+'%'));}
  });
})();

/* Optional shipping protection, updated in place without closing the drawer. */
(() => {
  let busy = false;
  document.addEventListener('change', async event => {
    const checkbox = event.target.closest?.('[data-vv-protection]');
    if (!checkbox) return;
    if (busy) { checkbox.checked = !checkbox.checked; return; }
    const selected = checkbox.checked;
    const variantId = checkbox.dataset.variantId;
    const root = window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('cart-drawer');
    const wasOpen = Boolean(drawer?.classList.contains('active'));
    const controls = [...document.querySelectorAll('[data-vv-protection],button[name="checkout"]')];
    const states = controls.map(control => control.disabled);
    const container = checkbox.closest('.vv-protection');
    const originalError = container.querySelector('[role="alert"]');
    originalError.hidden = true;
    busy = true; controls.forEach(control => control.disabled = true);
    const targets = [];
    if (drawer) targets.push({id:'cart-drawer',selector:'#CartDrawer',target:'#CartDrawer'});
    if (document.getElementById('cart-icon-bubble')) targets.push({id:'cart-icon-bubble',selector:'.shopify-section',target:'#cart-icon-bubble'});
    for (const id of ['main-cart-items','main-cart-footer']) {
      const element = document.getElementById(id);
      if (element?.dataset.id) targets.push({id:element.dataset.id,selector:'#'+id,target:'#'+id});
    }
    const sectionIds = [...new Set(targets.map(target => target.id))].slice(0,5);
    let mutationConfirmed = false;
    try {
      const response = await fetch(root+'cart/update.js', {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({updates:{[variantId]:selected?1:0},sections:sectionIds,sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status || data.errors) throw new Error(typeof data.description === 'string' ? data.description : 'No se pudo actualizar la protección. Intentá nuevamente.');
      mutationConfirmed = true;
      let sections = data.sections || {};
      // A cart update may succeed while section rendering fails; retry rendering only.
      if (sectionIds.some(id => !sections[id])) {
        const url = new URL(location.href);url.searchParams.set('sections',sectionIds.join(','));
        const htmlResponse = await fetch(url.toString(),{headers:{Accept:'application/json'}});
        if (!htmlResponse.ok) throw new Error('La protección se actualizó. No pudimos refrescar el total; intentá actualizar el carrito antes de pagar.');
        sections = {...sections,...await htmlResponse.json()};
      }
      const swaps = targets.map(target => {
        const html = sections[target.id];
        const source = html && new DOMParser().parseFromString(html,'text/html').querySelector(target.selector);
        const destination = document.querySelector(target.target);
        if (!source || !destination) throw new Error('La protección se actualizó. No pudimos refrescar el total; actualizá el carrito antes de pagar.');
        return {source,destination};
      });
      for (const {source,destination} of swaps) destination.innerHTML = source.innerHTML;
      drawer?.classList.toggle('is-empty',data.item_count===0);
      document.querySelector('cart-items')?.classList.toggle('is-empty',data.item_count===0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty',data.item_count===0);
      if (wasOpen && drawer) {
        // Keep the same drawer element and active class, preserving open state.
        drawer.classList.add('active');
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
        const next = drawer.querySelector('[data-vv-protection]') || drawer.querySelector('[name="checkout"]');
        if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer') || drawer,next);
        next?.focus({preventScroll:true});
      }
      // Sync other native cart components without requesting a second cart mutation.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:data});
      }
    } catch (err) {
      const error = document.querySelector(wasOpen ? 'cart-drawer .vv-protection [role="alert"]' : '.vv-protection [role="alert"]') || originalError;
      if (!mutationConfirmed) checkbox.checked = !selected;
      error.textContent = err.message || 'No se pudo actualizar la protección. Revisá tu conexión.';
      error.hidden = false;
      // Never allow checkout with stale totals after a confirmed mutation/render failure.
      if (mutationConfirmed) document.querySelectorAll('button[name="checkout"]').forEach(button => {button.disabled=true;button.dataset.vvStale='true';});
    } finally {
      controls.forEach((control,index) => {if(control.isConnected && control.dataset.vvStale!=='true') control.disabled=states[index];});
      busy = false;
    }
  });
})();
